//import { PowerOffSharp } from "@mui/icons-material";
import React, { forwardRef, useImperativeHandle, useState } from "react";

// this component include label, three input text box
// required *, and error state with error message

// base on input props.isRequired,
// update the className, to show error, and required

function DOBInput(props, ref) {
  // var date = convert(props.value);
  const [date, setDate] = useState(convert(props.value));
  const [allWrong, setAllWrong] = useState(false);
  const [dayWrong, setDayWrong] = useState(false);
  const [monthWrong, setMonthWrong] = useState(false);
  const [yearWrong, setYearWrong] = useState(false);
  //const [errorMessages, setErrorMessages] = useState("");
  const [errorMessageState0, setErrorMessageState0] = useState(false);
  const [errorMessageState1, setErrorMessageState1] = useState(false);
  const [errorMessageState2, setErrorMessageState2] = useState(false);
  const [errorMessageState3, setErrorMessageState3] = useState(false);
  const [errorMessageState4, setErrorMessageState4] = useState(false);
  const [lastDayOfMonth, setLastDayOfMonth] = useState("30");

  // useEffect(() => {
  //   //init();
  //   return () => console.log("after init date ", date);
  // }, [props.errorMessage]); // <-- empty array here make it only rnu once

  // on load setupdate
  // function init() {
  //   setDate(convert(props.value));
  // }

  // use ref, parent call from outside

  useImperativeHandle(ref, () => ({
    doValidate: () => {
      handleBlur("yes");
    },
    clean: () => {
      cleanAllfields();
    },
    reset: () => {
      resetAllfields();
    }
  }));

  // convert and validate input date string
  function convert(dateString) {
    //console.log("--dateString ", dateString);
    // format has to be either 01/01/2000 or 1/1/2000
    if (
      dateString === undefined ||
      dateString === null ||
      dateString.length < 8
    ) {
      return { month: "", day: "", year: "" };
    }

    // First check for the pattern either 01/01/2000 or 1/1/2000
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return { month: "", day: "", year: "" };
    }
    // split date
    var parts = dateString.split("/");

    // add leading zero
    if (parts[0].length === 1) {
      parts[0] = "0" + parts[0];
    }
    // add leading zero
    if (parts[1].length === 1) {
      parts[1] = "0" + parts[1];
    }
    // return as object array
    return { month: parts[0], day: parts[1], year: parts[2] };
  }

  function onChangeDate(e, w) {
    //console.log("onChangeDate e", e.target.value);
    //console.log("onChangeDate date = ", date);
    switch (w) {
      case "m":
        setDate({
          month: e.target.value.slice(0, 2),
          day: date.day,
          year: date.year
        });
        break;
      case "d":
        setDate({
          month: date.month,
          day: e.target.value.slice(0, 2),
          year: date.year
        });
        break;
      case "y":
        setDate({
          month: date.month,
          day: date.day,
          year: e.target.value.slice(0, 4)
        });
        break;
      default:
        break;
    }

    var returnStr =
      date.month.toString() +
      "/" +
      date.day.toString() +
      "/" +
      date.year.toString();
    //console.log("DOB onChange date ", returnStr);
    props.onChange(returnStr);
  }

  // on blue, add leading zero if needed
  function onBlurDate(e, w) {
    //console.log("onBlurDate date = ", date);
    switch (w) {
      case "m":
        if (e.target.value.length === 1) {
          setDate({
            month: "0" + e.target.value,
            day: date.day,
            year: date.year
          });
        }
        break;
      case "d":
        if (e.target.value.length === 1) {
          setDate({
            month: date.month,
            day: "0" + e.target.value,
            year: date.year
          });
        }
        break;
      default:
        break;
    }

    // var returnStr =
    //   date.month.toString() +
    //   "/" +
    //   date.day.toString() +
    //   "/" +
    //   date.year.toString();
    //console.log("DOB onBlur date ", returnStr);
    //props.onBlur(returnStr);
  }

  //reset all error messages
  function onFocusDate(e, w) {
    // setErrorMessageState0(false);
    // setErrorMessageState1(false);
    // setErrorMessageState2(false);
    // setErrorMessageState3(false);
    // setErrorMessageState4(false);
    // setAllWrong(false);
    // setDayWrong(false);
    // setMonthWrong(false);
    // setYearWrong(false);
  }

  // reset all error , and empty all field
  function cleanAllfields() {
    setErrorMessageState0(false);
    setErrorMessageState1(false);
    setErrorMessageState2(false);
    setErrorMessageState3(false);
    setErrorMessageState4(false);
    setAllWrong(false);
    setDayWrong(false);
    setMonthWrong(false);
    setYearWrong(false);
    setDate(convert(""));
    //console.log("-- clear date", date);
    //console.log("--props = ", props.value);
  }

  // reset all error , and reset init value
  function resetAllfields() {
    setErrorMessageState0(false);
    setErrorMessageState1(false);
    setErrorMessageState2(false);
    setErrorMessageState3(false);
    setErrorMessageState4(false);
    setAllWrong(false);
    setDayWrong(false);
    setMonthWrong(false);
    setYearWrong(false);
    setDate(convert(props.value));
    console.log("--props = ", props.value);
  }

  // leaving the component, outside the three input box
  function handleBlur(e) {
    // reset all errors
    // setAllWrong(false);
    // setDayWrong(false);
    // setMonthWrong(false);
    // setYearWrong(false);
    //setErrorMessages("");
    let errors = "";
    //console.log("all error messages ",props.errorMessageArray);

    //console.log("onBlue handleBlur ", date, e.currentTarget, document.activeElement);
    // if calling from parent, does not have e
    var letgo = false;
    var currentTarget = false;
    if (e === "yes") {
      letgo = true;
    } else {
      currentTarget = e.currentTarget;
    }
    // Give browser time to focus the next element
    requestAnimationFrame(() => {
      // Check if the new focused element is a child of the original container
      if (letgo || !currentTarget.contains(document.activeElement)) {
        // console.log(
        //   "click outside",
        //   !currentTarget.contains(document.activeElement)
        // );
        //console.log("date = ", date);

        //var today = new Date();
        // console.log(
        //   "now is ",
        //   today.getMonth() + 1,
        //   "/",
        //   today.getDate(),
        //   "/",
        //   today.getFullYear(),
        //   "allowFutureDate = ",
        //   props.allowFutureDate
        // );

        // days in the month
        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        // Adjust for leap years
        if (
          date.year % 400 === 0 ||
          (date.year % 100 !== 0 && date.year % 4 === 0)
        ) {
          monthLength[1] = 29;
        }
        //console.log("--", date.year, date.month, date.day);
        let m = true; // flag for month, if month is correct
        // missing any of three fields
        if (date.year === "" || date.month === "" || date.day === "") {
          errors += "Date of birth is required ";
          setErrorMessageState0(true);
          setAllWrong(true);
        } else {
          setErrorMessageState0(false);
          setAllWrong(false);
        }
        if (date.year === "" || date.year === 0) {
          setYearWrong(true);
        } else {
          setYearWrong(false);
        }
        if (date.month === "" || date.month === 0) {
          setMonthWrong(true);
        } else {
          setMonthWrong(false);
        }
        if (date.day === "" || date.day === 0) {
          setDayWrong(true);
        } else {
          setDayWrong(false);
        }
        // month field is 0 or 00
        if (
          date.month === "" ||
          date.month === "00" ||
          date.month <= 0 ||
          date.month >= 13
        ) {
          errors += "Enter a month between 1 and 12 ";
          setErrorMessageState1(true);
          m = false; // month is wrong
          setMonthWrong(true);
        } else {
          setErrorMessageState1(false);
          m = true; // month is wrong
          setMonthWrong(false);
        }
        // has month, and day field is 0 or 00 or day is too big
        if (m) {
          if (date.day <= 0 || date.day > monthLength[date.month - 1]) {
            setErrorMessageState2(true);
            setLastDayOfMonth(monthLength[date.month - 1]);
            setDayWrong(true);
            errors +=
              "Enter a day between 1 and " + monthLength[date.month - 1] + " ";
          } else {
            setErrorMessageState2(false);
            setDayWrong(false);
          }
        } else {
          if (date.day <= 0 || date.day >= 32) {
            errors += "Enter a day between 1 and 31 ";
            setErrorMessageState2(true);
            setLastDayOfMonth("31");
            setDayWrong(true);
          } else {
            setErrorMessageState2(false);
            setDayWrong(false);
          }
        }

        // date is in future
        if (date.year < 1900 || date.year > 2100) {
          errors += "Enter a year between 1900 and 2100 ";
          //console.error("year is wrong", date.year);
          setErrorMessageState3(true);
          setYearWrong(true);
          setAllWrong(true);
        } else {
          setErrorMessageState3(false);
          setYearWrong(false);
          setAllWrong(false);
        }

        var cToday = new Date().getTime();
        var iToday = new Date(date.year, date.month - 1, date.day).getTime();
        if (!props.allowFutureDate && cToday <= iToday) {
          errors += "Enter a date in the past ";
          setErrorMessageState4(true);
          setYearWrong(true);
          setDayWrong(true);
          setMonthWrong(true);
          setAllWrong(true);
          //console.log("year is next year", date.year);
          //setYearWrong(false);
        } else {
          if (errors === "") {
            setErrorMessageState4(false);
            setYearWrong(false);
            setDayWrong(false);
            setMonthWrong(false);
            setAllWrong(false);
          }
        }

        // check format before return
        //console.log("date = ", date);
        let obj = convert(
          date.month.toString() +
            "/" +
            date.day.toString() +
            "/" +
            date.year.toString()
        );
        //console.log("obj = ", obj);
        var returnStr =
          obj.month.toString() +
          "/" +
          obj.day.toString() +
          "/" +
          obj.year.toString();
        //console.log("DOB onChange date ", returnStr);
        //props.onChange(returnStr);
        if (errors.length === 0) {
          //console.log("return date", errors, returnStr);
          props.onBlur(returnStr); // empty for no error
        } else {
          //console.log("return error message to formik ", errors);
          if (props.isRequired) {
            props.onBlur("error");
          } else {
            // not required, two possible
            if( date.month.toString() !== "" || date.day.toString() !== "" || date.year.toString() !== "" ){ 
                // one of the field has something, and not required, show error and return error              	
              	props.onBlur("error");              
            } else { 
              	// all input fields are empty, and not required, don't show error and return nothing  
	            setErrorMessageState1(false);
	            setErrorMessageState2(false);
	            setErrorMessageState3(false);
	            setErrorMessageState4(false);
	            setYearWrong(false);
	            setDayWrong(false);
	            setMonthWrong(false);
	            setAllWrong(false);     
            	errors = "";
            	props.onBlur("");
            }
          }
        }

        // if (cToday >= iToday) {
        //   console.log("pass day");
        // } else {
        //   console.log("future day");
        //   if (props.allowFutureDate) {
        //     //allWrong(false);
        //   } else {
        //     setAllWrong(true);
        //   }
        // }

        // if (date.month > 0 && date.month <= 12) {
        //   console.log("month is OK", date.month);
        //   //setMonthWrong(false);
        // } else {
        //   console.error("month is wrong", date.month);
        //   setMonthWrong(true);
        //   setAllWrong(true);
        // }

        // if (date.day > 0 && date.day <= monthLength[date.month - 1]) {
        //   console.log("day is OK", date.day);
        //   //setDayWrong(false);
        // } else {
        //   console.error("day is wrong", date.day);
        //   setDayWrong(true);
        //   setAllWrong(true);
        // }
      }

      //setErrorMessages(errors);
    });
  }

  return (
    <div className="DOBinputbox">
      {/* //<div className="DOBinputbox"> */}
      {/* display label */}
      <label
        className={`DOBinputbox__label ${
          allWrong ? "inputbox__label--error" : ""
        }
        ${props.isDisabled ? "inputbox__label--disabled" : ""}
        `}
      >
        <div>{props.labelText}
        <span
              className="inputbox__required"
              style={props.isRequired ? {} : { display: "none" }}
            >
              *
            </span>
        </div>
        {/* <div>*/}
        {/* display help message */}
        {/*<span className="inputbox__help">{props.helpMessage}</span>
        </div> */}
        <div className="DOB-error-message-box">
          {/* display errorMessage or formik error message */}
          <span
            className="DOBinputbox__error"
            style={
              errorMessageState0 && props.isRequired ? {} : { display: "none" }
            }
          >
            {props.errorMessageArray[0]}
          </span>
          <span
            className="DOBinputbox__error"
            style={errorMessageState1 ? {} : { display: "none" }}
          >
            {props.errorMessageArray[1]}
          </span>
          <span
            className="DOBinputbox__error"
            style={errorMessageState2 ? {} : { display: "none" }}
          >
            {props.errorMessageArray[2]} {lastDayOfMonth}.
          </span>
          <span
            className="DOBinputbox__error"
            style={errorMessageState3 ? {} : { display: "none" }}
          >
            {props.errorMessageArray[3]}
          </span>
          <span
            className="DOBinputbox__error"
            style={errorMessageState4 ? {} : { display: "none" }}
          >
            {props.errorMessageArray[4]}
          </span>
        </div>
        {/* text input box */}
        <div className="DOBInputs" onBlur={(e) => handleBlur(e)}>
          <input className="hide_div" />
          <div>
            <label
              className={`inputbox__label ${
                monthWrong ? "DOBinputbox__label--error" : ""
              }
              ${props.isDisabled ? "inputbox__label--disabled" : ""}
              `}
            >
              {props.monthLabel ? props.monthLabel : "Month"}
            
            <span
              className="inputbox__required"
              style={props.isRequired ? {} : { display: "none" }}
            >
              *
            </span></label>
            <input
              id={props.id + "_m"}
              required={props.isRequired ? true : false}
              placeholder={props.placeholder}
              className={`DOBinputbox__MM__textbox ${
                monthWrong ? "DOBinputbox__MM__textbox--error" : ""
              }`}
              value={date.month}
              onChange={(e) => onChangeDate(e, "m")}
              onBlur={(e) => onBlurDate(e, "m")}
              onFocus={(e) => onFocusDate(e, "m")}
              disabled={props.isDisabled ? true : false}
              type="text"
              maxLength="2"
              onKeyDown={(evt) =>
                //["e", "E", "+", "-", "."].includes(evt.key) &&
                ![
                  8,
                  9,
                  37,
                  39,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  96,
                  97,
                  98,
                  99,
                  100,
                  101,
                  102,
                  103,
                  104,
                  105
                ].includes(evt.keyCode) && evt.preventDefault()
              }
            />
          </div>
          <div>
            <label
              className={`inputbox__label ${
                dayWrong ? "DOBinputbox__label--error" : ""
              }
              ${props.isDisabled ? "inputbox__label--disabled" : ""}
              `}
            >
              {props.dayLabel ? props.dayLabel : "Day"}
            
            <span
              className="inputbox__required"
              style={props.isRequired ? {} : { display: "none" }}
            >
              *
            </span></label>
            <input
              id={props.id + "_d"}
              required={props.isRequired ? true : false}
              //placeholder={props.placeholder}
              className={`DOBinputbox__DD__textbox ${
                dayWrong ? "DOBinputbox__DD__textbox--error" : ""
              }`}
              value={date.day}
              onChange={(e) => onChangeDate(e, "d")}
              onBlur={(e) => onBlurDate(e, "d")}
              onFocus={(e) => onFocusDate(e, "d")}
              disabled={props.isDisabled ? true : false}
              type="text"
              maxLength="2"
              onKeyDown={(evt) =>
                //["e", "E", "+", "-", "."].includes(evt.key) &&
                ![
                  8,
                  9,
                  37,
                  39,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  96,
                  97,
                  98,
                  99,
                  100,
                  101,
                  102,
                  103,
                  104,
                  105
                ].includes(evt.keyCode) && evt.preventDefault()
              }
            />
          </div>
          <div>
            <label
              className={`inputbox__label ${
                yearWrong ? "DOBinputbox__label--error" : ""
              }
              ${props.isDisabled ? "inputbox__label--disabled" : ""}
              `}
            >
              {props.yearLabel ? props.yearLabel : "Year"}
            
            <span
              className="inputbox__required"
              style={props.isRequired ? {} : { display: "none" }}
            >
              *
            </span></label>
            <input
              id={props.id + "_y"}
              required={props.isRequired ? true : false}
              //placeholder={props.placeholder}
              className={`DOBinputbox__YYYY__textbox ${
                yearWrong ? "DOBinputbox__YYYY__textbox--error" : ""
              }`}
              value={date.year}
              onChange={(e) => onChangeDate(e, "y")}
              onBlur={(e) => onBlurDate(e, "y")}
              onFocus={(e) => onFocusDate(e, "y")}
              disabled={props.isDisabled ? true : false}
              type="text"
              maxLength="4"
              onKeyDown={(evt) =>
                //["e", "E", "+", "-", "."].includes(evt.key) &&
                ![
                  8,
                  9,
                  37,
                  39,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  96,
                  97,
                  98,
                  99,
                  100,
                  101,
                  102,
                  103,
                  104,
                  105
                ].includes(evt.keyCode) && evt.preventDefault()
              }
            />
          </div>
        </div>
      </label>
    </div>
  );
}

export default forwardRef(DOBInput);